/* eslint-disable */
import { Metrics, Colors, Fonts } from '../../Themes'
import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    marginBottom: 30,
    marginTop: 30,
  },

  text: {
    alignSelf: 'center',
   
    fontSize: 14,
    lineHeight: 18,
  },

  link: {
  
    textDecorationLine: 'underline',
  }
})


